import { Genre } from '@fenderdigital/api-definitions/play';
import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';
import { ButtonBase as Button } from '@fenderdigital/ui/Button';
import MarkCompleteButtonContent from './MarkCompleteButtonContent';

// TODO maybe move this somewhere else
export interface MarkCompleteData {
  'path-id': string;
  'playlist-id': string;
  style: Genre;
  title: string;
  instrument?: string;
}

interface MarkCompleteProps {
  isComplete: boolean;
  isCourse: boolean;
  onConfirm: () => void;
  handleCloseEllipsis: () => void;
}

const MarkCompleteContainer = styled.div`
  width: 16rem;
  padding: ${({ theme: { spacing } }): string => spacing.sm3} 0;

  button {
    display: block;
  }
`;

const MarkComplete: React.FC<MarkCompleteProps> = ({
  isComplete = false,
  onConfirm,
  handleCloseEllipsis,
}) => {
  const onCompleteClick = (event: SyntheticEvent): void => {
    event.preventDefault();
    handleCloseEllipsis && handleCloseEllipsis();
    onConfirm();
  };

  return (
    <MarkCompleteContainer data-id="mark-complete-dropdown-container">
      <Button
        isFluid
        variant="ghost"
        colorScheme="white"
        onClick={onCompleteClick}
        data-id="mark-complete"
      >
        <MarkCompleteButtonContent isComplete={isComplete} />
      </Button>
    </MarkCompleteContainer>
  );
};

export default MarkComplete;
